import { render, staticRenderFns } from "./FeatureSelect.vue?vue&type=template&id=6bc2add8&scoped=true&"
import script from "./FeatureSelect.vue?vue&type=script&lang=ts&"
export * from "./FeatureSelect.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureSelect.vue?vue&type=style&index=0&id=6bc2add8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2add8",
  null
  
)

export default component.exports